import { render, staticRenderFns } from "./PickOrderItem.vue?vue&type=template&id=60f1db4e&scoped=true"
import script from "./PickOrderItem.vue?vue&type=script&lang=js"
export * from "./PickOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1db4e",
  null
  
)

export default component.exports